'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSnackBarButton = exports.StyledSnackbarBody = exports.StyledSnackBar = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  bottom: 0;\n  display: flex;\n  left: 50%;\n  opacity: ', ';\n  position: fixed;\n  transform: ', ';\n  transition-duration: ', 'ms;\n  transition-property: opacity, transform;\n  transition-timing-function: ease-out;\n  z-index: 999;\n'], ['\n  bottom: 0;\n  display: flex;\n  left: 50%;\n  opacity: ', ';\n  position: fixed;\n  transform: ', ';\n  transition-duration: ', 'ms;\n  transition-property: opacity, transform;\n  transition-timing-function: ease-out;\n  z-index: 999;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: 0;\n  color: ', ';\n  flex-grow: 1;\n  font-family: inherit;\n  height: ', ';\n  line-height: ', ';\n  max-width: inherit;\n  min-width: inherit;\n  padding: 0 ', ';\n  text-align: ', ';\n  width: calc(100vw - (', ' * 2));\n\n  @media (min-width: 768px) {\n    border-top-left-radius: ', ';\n    border-top-right-radius: ', ';\n    flex-grow: 0;\n    max-width: ', ';\n    min-width: ', ';\n    width: auto;\n  }\n'], ['\n  background-color: ', ';\n  border-radius: 0;\n  color: ', ';\n  flex-grow: 1;\n  font-family: inherit;\n  height: ', ';\n  line-height: ', ';\n  max-width: inherit;\n  min-width: inherit;\n  padding: 0 ', ';\n  text-align: ', ';\n  width: calc(100vw - (', ' * 2));\n\n  @media (min-width: 768px) {\n    border-top-left-radius: ', ';\n    border-top-right-radius: ', ';\n    flex-grow: 0;\n    max-width: ', ';\n    min-width: ', ';\n    width: auto;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: transparent;\n  border: 0;\n  color: ', ';\n  cursor: pointer;\n  display: block;\n  float: right;\n  font-family: ', ';\n  font-size: ', 'px;\n  margin-left: ', ';\n  margin-right: -16px;\n  outline: 0;\n  padding: 0 8px;\n'], ['\n  background-color: transparent;\n  border: 0;\n  color: ', ';\n  cursor: pointer;\n  display: block;\n  float: right;\n  font-family: ', ';\n  font-size: ', 'px;\n  margin-left: ', ';\n  margin-right: -16px;\n  outline: 0;\n  padding: 0 8px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSnackBar = exports.StyledSnackBar = _styledComponents2.default.div(_templateObject, function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.isOpen ? 'translate(-50%, 0)' : 'translate(-50%, 100%)';
}, function (props) {
  return props.transitionDuration ? props.transitionDuration : 0;
});

StyledSnackBar.displayName = 'StyledSnackBar';
var StyledSnackbarBody = exports.StyledSnackbarBody = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
}, function (props) {
  return props.height;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.sidePadding;
}, function (_ref) {
  var action = _ref.action;
  return action ? 'left' : 'center';
}, function (props) {
  return props.sidePadding;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.minWidth;
});

StyledSnackbarBody.displayName = 'StyledSnackbarBody';
var StyledSnackBarButton = exports.StyledSnackBarButton = _styledComponents2.default.button(_templateObject3, function (props) {
  return props.theme.color.primary;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.size['3'];
}, function (props) {
  return props.sidePadding;
});
StyledSnackBarButton.displayName = 'StyledSnackBarButton';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-snackbar/styles.js
// module id = 3038
// module chunks = 4